import React from "react";

import "./Toolbar.css";

const ToolbarWrapper = props => {
  return <div className="table-toolbar">{props.children}</div>;
};

export default ToolbarWrapper;



// WEBPACK FOOTER //
// ./src/system/containers/Table/components/Toolbar.jsx